import { EventRegistrationType, TEvent, TEventCard } from '@app/models';
import { useMemo } from 'react';

export const useRegistrationNeeded = (event: TEvent | TEventCard | undefined): boolean => {
  return useMemo(
    () =>
      event?.registrationType
        ? [EventRegistrationType.REGISTRATION, EventRegistrationType.VIP].includes(event.registrationType)
        : false,
    [event?.registrationType],
  );
};
